import gql from "graphql-tag";

export const RELATED_PRODUCTS = gql`
  query getRelatedProductsByCategory($categoryId: [Int], $limit: Int) {
    products(where: { categoryIdIn: $categoryId }, first: $limit) {
      nodes {
        id
        ... on SimpleProduct {
          id
          productId
          slug
          name
          image {
            id
            sourceUrl
          }
          salePrice
          regularPrice
          stockStatus
          stockQuantity
        }
      }
    }
  }
`;

export const GET_RELATED_PRODUCTS = gql`
  query getRelatedProducts($productId: [Int]) {
    products(where: { include: $productId }) {
      nodes {
        id
        ... on SimpleProduct {
          id
          productId
          slug
          name
          image {
            id
            sourceUrl
          }
          salePrice
          regularPrice
          stockStatus
          stockQuantity
        }
      }
    }
  }
`;
